 <!-- FOR SERVICE DATE CHANGES ONLY 
<div class="overlay" *ngIf="type == 'ofs_modal' && toggleValue">
  <div class="powertrain-modal">
    <div class="powertrain-modal-header">
      <div class="powertrain-modal-title">Meter Service Record</div>
    </div>
    <div class="powertrain-modal-body">
      <form [formGroup]="form" (ngSubmit)="saveServiceModalDataBox()">
        <div class="form-group mx-2 my-3">
          <label for="performance"> Service Start Date </label>
          <input
            id="performance"
            type="date"
            class="form-control"
            formControlName="next_service_start_date"
          />
        </div>
        <div class="form-group mx-2 my-3">
          <label for="performance"> Service End Date </label>
          <input
            id="performance"
            type="date"
            class="form-control"
            formControlName="next_service_end_date"
          />
        </div>
        <div class="form-group mx-2 my-3">
          <label for="performance"> Service Performed </label>
          <input
            id="performance"
            type="text"
            class="form-control"
            defaultValue="{{ form.value.next_service_performed }}"
            formControlName="next_service_performed"
          />
        </div>
        <div class="form-group mx-2 my-3">
          <label for="performance"> Service Performed By </label>
          <input
            id="performance"
            type="text"
            class="form-control"
            defaultValue="{{ form.value.next_service_performed_by }}"
            formControlName="next_service_performed_by"
          />
        </div>
        <div class="powertrain-modal-footer flex_center_end">
          <button
            *ngIf="!loader"
            type="submit"
            class="btn btn-primary"
            [disabled]="form.invalid || form.pristine"
          >
            Update
          </button>
          <div
            *ngIf="loader"
            class="spinner-container charts-loader"
            style="margin-right: 10px"
          >
            <div class="spinner-border text-primary" role="status"></div>
          </div>
          <button
            type="button"
            class="btn btn-light"
            (click)="closeServiceModalBox()"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  </div>
</div> -->

<!--  ---------------------------------------GREASING MODAL ------------------------- -->
<!-- <div class="overlay" *ngIf="type == 'service_modal'">
  <div class="powertrain-modal">
    <div class="powertrain-modal-header">
      <div class="powertrain-modal-title">Meter Greasing Record</div>
    </div>
    <div class="powertrain-modal-body">
      <form [formGroup]="gform" (ngSubmit)="saveGreasingModalDataBox()">
        <div class="form-group mx-2 my-3">
          <label for="performance"> Greasing Start Date </label>
          <input
            id="performance"
            type="date"
            class="form-control"
            formControlName="next_greasing_start_date"
          />
        </div>
        <div class="form-group mx-2 my-3">
          <label for="performance"> Greasing End Date </label>
          <input
            id="performance"
            type="date"
            class="form-control"
            formControlName="next_greasing_end_date"
          />
        </div>
        <div class="form-group mx-2 my-3">
          <label for="performance"> Greasing Performed </label>
          <input
            id="performance"
            type="text"
            class="form-control"
            defaultValue="{{ form.value.next_greasing_performed }}"
            formControlName="next_greasing_performed"
            disabled
          />
        </div>
        <div class="form-group mx-2 my-3">
          <label for="performance"> Greasing Performed By </label>
          <input
            id="performance"
            type="text"
            class="form-control"
            defaultValue="{{ form.value.next_greasing_performed_by }}"
            formControlName="next_greasing_performed_by"
          />
        </div>
        <div class="powertrain-modal-footer flex_center_end">
          <button
            *ngIf="!loader"
            type="submit"
            class="btn btn-primary"
            [disabled]="gform.invalid || gform.pristine"
          >
            Update
          </button>
          <div
            *ngIf="loader"
            class="spinner-container charts-loader"
            style="margin-right: 10px"
          >
            <div class="spinner-border text-primary" role="status"></div>
          </div>
          <button
            type="button"
            class="btn btn-light"
            (click)="closeGreasingModalBox()"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  </div>
</div> -->

<!-- ----------------------------------------- BACK IN SERVICE MODAL-------------------->
<div *ngIf="type == 'ofs_modal'" class="overlay">
  <div class="powertrain-modal" style="width: 30vw">
    <div class="powertrain-modal-header">
      <div class="powertrain-modal-title">Confirm your choice</div>
    </div>
    <div class="powertrain-modal-body">
      <div class="" style="padding: 80px">
        Are you sure you want to proceed with your selection ?
      </div>
      <div class="powertrain-modal-footer flex_center_end">
        <button
        *ngIf="!loader"
        (click)="saveOFSToggle()"
          class="btn btn-primary"
          >
          Confirm
        </button>
        <div
        *ngIf="loader"
        class="spinner-container charts-loader"
        style="margin-right: 10px"
        >
        <div class="spinner-border text-primary" role="status"></div>
      </div>
      <button
      type="button"
      class="btn btn-light"
      (click)="closeOutForServiceModalBox()"
      >
      Cancel
    </button>
  </div>
</div>
</div>
</div>
<!-- ----------------------------------------- BACK IN SERVICE MODAL ENDS ------------------------------------->

<!-- ----------------------------------------- GREASING MODAL V2 STARTS ------------------------------------->
<div class="overlay" *ngIf="type == 'greasing_modal'">
  <div class="powertrain-modal">
    <div class="powertrain-modal-header">
      <div class="powertrain-modal-title">Meter Greasing Record</div>
    </div>
    <div class="powertrain-modal-body">
      <form [formGroup]="gformV2" (ngSubmit)="saveGreasingModalDataBoxV2()">
        <div class="form-group mx-2 my-3">
          <!-- when we send the meter for service last time needto be disabled only for read mode -->
          <label for="availability"> Last Greasing Date </label>
          <input
            id="availability"
            type="date"
            class="form-control"
            formControlName="last_greasing"
          />
        </div>
        <div class="form-group mx-2 my-3">
          <!-- when we send the meter for service last time needto be disabled only for read mode -->
          <label for="availability"> Number of Hrs for next greasing </label>
          <input
            id="availability"
            type="number"
            class="form-control"
            formControlName="nxt_running_hrs"
          />
        </div>
        <div class="form-group mx-2 my-3">
          <label for="performance"> Suggested Next Greasing </label>
          <input
            id="performance"
            type="text"
            disabled
            class="form-control"
            formControlName="suggested_greasing_date"
          />
        </div>
        <div class="powertrain-modal-footer flex_center_end">
          <button
            *ngIf="!loader"
            type="submit"
            class="btn btn-primary"
          >
            Update
          </button>
          <div
            *ngIf="loader"
            class="spinner-container charts-loader"
            style="margin-right: 10px"
          >
            <div class="spinner-border text-primary" role="status"></div>
          </div>
          <button type="button" class="btn btn-light" (click)="closeGreasingModalBox()">
            Cancel
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- ----------------------------------------- GREASING MODAL V2 ENDS ------------------------------------->